import * as ko from 'knockout';

import { BaseForm } from './base_form';
import * as driversApi from '../api/drivers';
import { Deferred } from '../utils/deferred';
import { asI18nText } from '../i18n_text';
import { createWithComponent } from '../utils/ko_utils';
import { Driver } from '../models/driver';

let template = require('raw-loader!../../templates/driver_edit.html').default;

class DriverEditScreen extends BaseForm<driversApi.DriverData> {
  entity = ko.validatedObservable<Driver>(null);

  constructor(
    params: {
      id: string;
      initialName?: string;
      result?: Deferred<driversApi.DriverData>;
    },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    let requestPromise = params.id ? driversApi.retrieve(params.id) : undefined;
    let promise = Promise.all([requestPromise]).then(([data]) => {
      this.entity(new Driver(data));
      if (!data && params.initialName) {
        this.entity().nameJson(asI18nText(params.initialName));
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (this.validateLocal(this.entity)) {
      let data = this.entity().toData();
      this.executeSaveRequest(driversApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.entity(), validation);
      });
    }
  };
}

export let driverEdit = {
  name: 'driver-edit',
  viewModel: createWithComponent(DriverEditScreen),
  template: template,
};

ko.components.register(driverEdit.name, driverEdit);
